import { ProductComparisonActionTypes } from '../../../enums/ActionEnums';
import { COMPARE_TRIGGERED_COMPONENT } from '../../../constants/CompareConstants';
export const productComparisonActions = {
    getInitialComparisonProducts: () => ({
        type: ProductComparisonActionTypes.INIT,
    }),
    fetchProducts: (payload) => ({
        type: ProductComparisonActionTypes.FETCH,
        payload,
    }),
    removeProduct: (index) => ({
        type: ProductComparisonActionTypes.REMOVE,
        payload: {
            index,
            sourceComponent: COMPARE_TRIGGERED_COMPONENT.comparePage,
        },
    }),
    getDeliveryPromise: (payload) => ({
        type: ProductComparisonActionTypes.GET_DELIVERY_PROMISE,
        payload,
    }),
    setDeliveryPromise: (payload) => ({
        type: ProductComparisonActionTypes.SET_DELIVERY_PROMISE,
        payload,
    }),
    createSelectSizeAction: (payload) => ({
        type: ProductComparisonActionTypes.COMPARE_ITEM_SELECT_SIZE,
        payload,
    }),
};
